import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="flex min-h-screen flex-col bg-ivory">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export const PageHero = ({ eyebrow, title, intro }) => (
  <section className="border-b border-gold/20 bg-white">
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-24">
      {eyebrow && <div className="eyebrow animate-fade-in">{eyebrow}</div>}
      <h1 className="mt-4 max-w-3xl text-4xl font-medium tracking-tight text-maroon sm:text-5xl lg:text-6xl animate-fade-up">{title}</h1>
      <div className="gold-rule mt-7" />
      {intro && <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink-muted lg:text-lg">{intro}</p>}
    </div>
  </section>
);
